/**
 * #post_message.ts
 *
 * Code generated by ts-proto. DO NOT EDIT.
 * @packageDocumentation
 */
/* eslint-disable */
import _m0 from "protobufjs/minimal.js";
import { Struct, Value } from "../../../../../google/protobuf/struct.js";
import { messageTypeRegistry } from "../../../../../typeRegistry.js";
import { CanRunAsUserEffect } from "../../../effect_types/v1alpha/app_permission.js";
import { CreateOrderEffect } from "../../../effect_types/v1alpha/create_order.js";
import { NavigateToUrlEffect } from "../../../effect_types/v1alpha/navigate_to_url.js";
import { RealtimeSubscriptionsEffect } from "../../../effect_types/v1alpha/realtime_subscription.js";
import { ShowFormEffect } from "../../../effect_types/v1alpha/show_form.js";
import { ShowToastEffect } from "../../../effect_types/v1alpha/show_toast.js";
import { UpdateRequestContextEffect } from "../../../effect_types/v1alpha/update_request_context.js";
import { WebViewImmersiveModeEffect } from "./immersive_mode.js";
import { WebViewLoginPromptEffect } from "./login.js";
import { WebViewPromotedTelemetryEffect } from "./promoted_telemetry.js";
import { WebViewScreenshotResponseEffect } from "./screenshot.js";
import { WebViewShareEffect } from "./share.js";
import { WebViewTelemetryEffect } from "./telemetry.js";
/**
 * Blocks only.
 *
 * @deprecated
 */
export var WebViewInternalMessageScope;
(function (WebViewInternalMessageScope) {
    /** CLIENT - Message is intended for the client only */
    WebViewInternalMessageScope[WebViewInternalMessageScope["CLIENT"] = 0] = "CLIENT";
    WebViewInternalMessageScope[WebViewInternalMessageScope["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(WebViewInternalMessageScope || (WebViewInternalMessageScope = {}));
export function webViewInternalMessageScopeFromJSON(object) {
    switch (object) {
        case 0:
        case "CLIENT":
            return WebViewInternalMessageScope.CLIENT;
        case -1:
        case "UNRECOGNIZED":
        default:
            return WebViewInternalMessageScope.UNRECOGNIZED;
    }
}
export function webViewInternalMessageScopeToJSON(object) {
    switch (object) {
        case WebViewInternalMessageScope.CLIENT:
            return 0;
        case WebViewInternalMessageScope.UNRECOGNIZED:
        default:
            return -1;
    }
}
function createBaseWebViewInternalMessage() {
    return {
        type: "",
        scope: 0,
        analytics: undefined,
        effect: undefined,
        realtimeEffect: undefined,
        immersiveMode: undefined,
        share: undefined,
        showToast: undefined,
        navigateToUrl: undefined,
        showForm: undefined,
        createOrder: undefined,
        realtime: undefined,
        canRunAsUser: undefined,
        telemetry: undefined,
        updateRequestContext: undefined,
        screenshot: undefined,
        loginPrompt: undefined,
        promotedTelemetry: undefined,
        id: undefined,
    };
}
export const WebViewInternalMessage = {
    $type: "devvit.ui.effects.web_view.v1alpha.WebViewInternalMessage",
    encode(message, writer = _m0.Writer.create()) {
        if (message.type !== "") {
            writer.uint32(10).string(message.type);
        }
        if (message.scope !== 0) {
            writer.uint32(16).int32(message.scope);
        }
        if (message.analytics !== undefined) {
            Struct.encode(Struct.wrap(message.analytics), writer.uint32(26).fork()).ldelim();
        }
        if (message.effect !== undefined) {
            Struct.encode(Struct.wrap(message.effect), writer.uint32(34).fork()).ldelim();
        }
        if (message.realtimeEffect !== undefined) {
            RealtimeSubscriptionsEffect.encode(message.realtimeEffect, writer.uint32(50).fork()).ldelim();
        }
        if (message.immersiveMode !== undefined) {
            WebViewImmersiveModeEffect.encode(message.immersiveMode, writer.uint32(58).fork()).ldelim();
        }
        if (message.share !== undefined) {
            WebViewShareEffect.encode(message.share, writer.uint32(66).fork()).ldelim();
        }
        if (message.showToast !== undefined) {
            ShowToastEffect.encode(message.showToast, writer.uint32(74).fork()).ldelim();
        }
        if (message.navigateToUrl !== undefined) {
            NavigateToUrlEffect.encode(message.navigateToUrl, writer.uint32(82).fork()).ldelim();
        }
        if (message.showForm !== undefined) {
            ShowFormEffect.encode(message.showForm, writer.uint32(90).fork()).ldelim();
        }
        if (message.createOrder !== undefined) {
            CreateOrderEffect.encode(message.createOrder, writer.uint32(98).fork()).ldelim();
        }
        if (message.realtime !== undefined) {
            RealtimeSubscriptionsEffect.encode(message.realtime, writer.uint32(106).fork()).ldelim();
        }
        if (message.canRunAsUser !== undefined) {
            CanRunAsUserEffect.encode(message.canRunAsUser, writer.uint32(114).fork()).ldelim();
        }
        if (message.telemetry !== undefined) {
            WebViewTelemetryEffect.encode(message.telemetry, writer.uint32(122).fork()).ldelim();
        }
        if (message.updateRequestContext !== undefined) {
            UpdateRequestContextEffect.encode(message.updateRequestContext, writer.uint32(130).fork()).ldelim();
        }
        if (message.screenshot !== undefined) {
            WebViewScreenshotResponseEffect.encode(message.screenshot, writer.uint32(138).fork()).ldelim();
        }
        if (message.loginPrompt !== undefined) {
            WebViewLoginPromptEffect.encode(message.loginPrompt, writer.uint32(146).fork()).ldelim();
        }
        if (message.promotedTelemetry !== undefined) {
            WebViewPromotedTelemetryEffect.encode(message.promotedTelemetry, writer.uint32(154).fork()).ldelim();
        }
        if (message.id !== undefined) {
            writer.uint32(42).string(message.id);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseWebViewInternalMessage();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.type = reader.string();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.scope = reader.int32();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.analytics = Struct.unwrap(Struct.decode(reader, reader.uint32()));
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.effect = Struct.unwrap(Struct.decode(reader, reader.uint32()));
                    continue;
                case 6:
                    if (tag !== 50) {
                        break;
                    }
                    message.realtimeEffect = RealtimeSubscriptionsEffect.decode(reader, reader.uint32());
                    continue;
                case 7:
                    if (tag !== 58) {
                        break;
                    }
                    message.immersiveMode = WebViewImmersiveModeEffect.decode(reader, reader.uint32());
                    continue;
                case 8:
                    if (tag !== 66) {
                        break;
                    }
                    message.share = WebViewShareEffect.decode(reader, reader.uint32());
                    continue;
                case 9:
                    if (tag !== 74) {
                        break;
                    }
                    message.showToast = ShowToastEffect.decode(reader, reader.uint32());
                    continue;
                case 10:
                    if (tag !== 82) {
                        break;
                    }
                    message.navigateToUrl = NavigateToUrlEffect.decode(reader, reader.uint32());
                    continue;
                case 11:
                    if (tag !== 90) {
                        break;
                    }
                    message.showForm = ShowFormEffect.decode(reader, reader.uint32());
                    continue;
                case 12:
                    if (tag !== 98) {
                        break;
                    }
                    message.createOrder = CreateOrderEffect.decode(reader, reader.uint32());
                    continue;
                case 13:
                    if (tag !== 106) {
                        break;
                    }
                    message.realtime = RealtimeSubscriptionsEffect.decode(reader, reader.uint32());
                    continue;
                case 14:
                    if (tag !== 114) {
                        break;
                    }
                    message.canRunAsUser = CanRunAsUserEffect.decode(reader, reader.uint32());
                    continue;
                case 15:
                    if (tag !== 122) {
                        break;
                    }
                    message.telemetry = WebViewTelemetryEffect.decode(reader, reader.uint32());
                    continue;
                case 16:
                    if (tag !== 130) {
                        break;
                    }
                    message.updateRequestContext = UpdateRequestContextEffect.decode(reader, reader.uint32());
                    continue;
                case 17:
                    if (tag !== 138) {
                        break;
                    }
                    message.screenshot = WebViewScreenshotResponseEffect.decode(reader, reader.uint32());
                    continue;
                case 18:
                    if (tag !== 146) {
                        break;
                    }
                    message.loginPrompt = WebViewLoginPromptEffect.decode(reader, reader.uint32());
                    continue;
                case 19:
                    if (tag !== 154) {
                        break;
                    }
                    message.promotedTelemetry = WebViewPromotedTelemetryEffect.decode(reader, reader.uint32());
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.id = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            type: isSet(object.type) ? globalThis.String(object.type) : "",
            scope: isSet(object.scope) ? webViewInternalMessageScopeFromJSON(object.scope) : 0,
            analytics: isObject(object.analytics) ? object.analytics : undefined,
            effect: isObject(object.effect) ? object.effect : undefined,
            realtimeEffect: isSet(object.realtimeEffect)
                ? RealtimeSubscriptionsEffect.fromJSON(object.realtimeEffect)
                : undefined,
            immersiveMode: isSet(object.immersiveMode)
                ? WebViewImmersiveModeEffect.fromJSON(object.immersiveMode)
                : undefined,
            share: isSet(object.share) ? WebViewShareEffect.fromJSON(object.share) : undefined,
            showToast: isSet(object.showToast) ? ShowToastEffect.fromJSON(object.showToast) : undefined,
            navigateToUrl: isSet(object.navigateToUrl) ? NavigateToUrlEffect.fromJSON(object.navigateToUrl) : undefined,
            showForm: isSet(object.showForm) ? ShowFormEffect.fromJSON(object.showForm) : undefined,
            createOrder: isSet(object.createOrder) ? CreateOrderEffect.fromJSON(object.createOrder) : undefined,
            realtime: isSet(object.realtime) ? RealtimeSubscriptionsEffect.fromJSON(object.realtime) : undefined,
            canRunAsUser: isSet(object.canRunAsUser) ? CanRunAsUserEffect.fromJSON(object.canRunAsUser) : undefined,
            telemetry: isSet(object.telemetry) ? WebViewTelemetryEffect.fromJSON(object.telemetry) : undefined,
            updateRequestContext: isSet(object.updateRequestContext)
                ? UpdateRequestContextEffect.fromJSON(object.updateRequestContext)
                : undefined,
            screenshot: isSet(object.screenshot) ? WebViewScreenshotResponseEffect.fromJSON(object.screenshot) : undefined,
            loginPrompt: isSet(object.loginPrompt) ? WebViewLoginPromptEffect.fromJSON(object.loginPrompt) : undefined,
            promotedTelemetry: isSet(object.promotedTelemetry)
                ? WebViewPromotedTelemetryEffect.fromJSON(object.promotedTelemetry)
                : undefined,
            id: isSet(object.id) ? globalThis.String(object.id) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.type !== "") {
            obj.type = message.type;
        }
        if (message.scope !== 0) {
            obj.scope = webViewInternalMessageScopeToJSON(message.scope);
        }
        if (message.analytics !== undefined) {
            obj.analytics = message.analytics;
        }
        if (message.effect !== undefined) {
            obj.effect = message.effect;
        }
        if (message.realtimeEffect !== undefined) {
            obj.realtimeEffect = RealtimeSubscriptionsEffect.toJSON(message.realtimeEffect);
        }
        if (message.immersiveMode !== undefined) {
            obj.immersiveMode = WebViewImmersiveModeEffect.toJSON(message.immersiveMode);
        }
        if (message.share !== undefined) {
            obj.share = WebViewShareEffect.toJSON(message.share);
        }
        if (message.showToast !== undefined) {
            obj.showToast = ShowToastEffect.toJSON(message.showToast);
        }
        if (message.navigateToUrl !== undefined) {
            obj.navigateToUrl = NavigateToUrlEffect.toJSON(message.navigateToUrl);
        }
        if (message.showForm !== undefined) {
            obj.showForm = ShowFormEffect.toJSON(message.showForm);
        }
        if (message.createOrder !== undefined) {
            obj.createOrder = CreateOrderEffect.toJSON(message.createOrder);
        }
        if (message.realtime !== undefined) {
            obj.realtime = RealtimeSubscriptionsEffect.toJSON(message.realtime);
        }
        if (message.canRunAsUser !== undefined) {
            obj.canRunAsUser = CanRunAsUserEffect.toJSON(message.canRunAsUser);
        }
        if (message.telemetry !== undefined) {
            obj.telemetry = WebViewTelemetryEffect.toJSON(message.telemetry);
        }
        if (message.updateRequestContext !== undefined) {
            obj.updateRequestContext = UpdateRequestContextEffect.toJSON(message.updateRequestContext);
        }
        if (message.screenshot !== undefined) {
            obj.screenshot = WebViewScreenshotResponseEffect.toJSON(message.screenshot);
        }
        if (message.loginPrompt !== undefined) {
            obj.loginPrompt = WebViewLoginPromptEffect.toJSON(message.loginPrompt);
        }
        if (message.promotedTelemetry !== undefined) {
            obj.promotedTelemetry = WebViewPromotedTelemetryEffect.toJSON(message.promotedTelemetry);
        }
        if (message.id !== undefined) {
            obj.id = message.id;
        }
        return obj;
    },
    create(base) {
        return WebViewInternalMessage.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseWebViewInternalMessage();
        message.type = object.type ?? "";
        message.scope = object.scope ?? 0;
        message.analytics = object.analytics ?? undefined;
        message.effect = object.effect ?? undefined;
        message.realtimeEffect = (object.realtimeEffect !== undefined && object.realtimeEffect !== null)
            ? RealtimeSubscriptionsEffect.fromPartial(object.realtimeEffect)
            : undefined;
        message.immersiveMode = (object.immersiveMode !== undefined && object.immersiveMode !== null)
            ? WebViewImmersiveModeEffect.fromPartial(object.immersiveMode)
            : undefined;
        message.share = (object.share !== undefined && object.share !== null)
            ? WebViewShareEffect.fromPartial(object.share)
            : undefined;
        message.showToast = (object.showToast !== undefined && object.showToast !== null)
            ? ShowToastEffect.fromPartial(object.showToast)
            : undefined;
        message.navigateToUrl = (object.navigateToUrl !== undefined && object.navigateToUrl !== null)
            ? NavigateToUrlEffect.fromPartial(object.navigateToUrl)
            : undefined;
        message.showForm = (object.showForm !== undefined && object.showForm !== null)
            ? ShowFormEffect.fromPartial(object.showForm)
            : undefined;
        message.createOrder = (object.createOrder !== undefined && object.createOrder !== null)
            ? CreateOrderEffect.fromPartial(object.createOrder)
            : undefined;
        message.realtime = (object.realtime !== undefined && object.realtime !== null)
            ? RealtimeSubscriptionsEffect.fromPartial(object.realtime)
            : undefined;
        message.canRunAsUser = (object.canRunAsUser !== undefined && object.canRunAsUser !== null)
            ? CanRunAsUserEffect.fromPartial(object.canRunAsUser)
            : undefined;
        message.telemetry = (object.telemetry !== undefined && object.telemetry !== null)
            ? WebViewTelemetryEffect.fromPartial(object.telemetry)
            : undefined;
        message.updateRequestContext = (object.updateRequestContext !== undefined && object.updateRequestContext !== null)
            ? UpdateRequestContextEffect.fromPartial(object.updateRequestContext)
            : undefined;
        message.screenshot = (object.screenshot !== undefined && object.screenshot !== null)
            ? WebViewScreenshotResponseEffect.fromPartial(object.screenshot)
            : undefined;
        message.loginPrompt = (object.loginPrompt !== undefined && object.loginPrompt !== null)
            ? WebViewLoginPromptEffect.fromPartial(object.loginPrompt)
            : undefined;
        message.promotedTelemetry = (object.promotedTelemetry !== undefined && object.promotedTelemetry !== null)
            ? WebViewPromotedTelemetryEffect.fromPartial(object.promotedTelemetry)
            : undefined;
        message.id = object.id ?? undefined;
        return message;
    },
};
messageTypeRegistry.set(WebViewInternalMessage.$type, WebViewInternalMessage);
function createBaseWebViewPostMessage() {
    return { type: "", data: undefined };
}
export const WebViewPostMessage = {
    $type: "devvit.ui.effects.web_view.v1alpha.WebViewPostMessage",
    encode(message, writer = _m0.Writer.create()) {
        if (message.type !== "") {
            writer.uint32(10).string(message.type);
        }
        if (message.data !== undefined) {
            Struct.encode(Struct.wrap(message.data), writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseWebViewPostMessage();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.type = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.data = Struct.unwrap(Struct.decode(reader, reader.uint32()));
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            type: isSet(object.type) ? globalThis.String(object.type) : "",
            data: isObject(object.data) ? object.data : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.type !== "") {
            obj.type = message.type;
        }
        if (message.data !== undefined) {
            obj.data = message.data;
        }
        return obj;
    },
    create(base) {
        return WebViewPostMessage.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseWebViewPostMessage();
        message.type = object.type ?? "";
        message.data = object.data ?? undefined;
        return message;
    },
};
messageTypeRegistry.set(WebViewPostMessage.$type, WebViewPostMessage);
function createBaseWebViewAppMessage() {
    return { message: undefined, jsonString: undefined };
}
export const WebViewAppMessage = {
    $type: "devvit.ui.effects.web_view.v1alpha.WebViewAppMessage",
    encode(message, writer = _m0.Writer.create()) {
        if (message.message !== undefined) {
            Value.encode(Value.wrap(message.message), writer.uint32(10).fork()).ldelim();
        }
        if (message.jsonString !== undefined) {
            writer.uint32(18).string(message.jsonString);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseWebViewAppMessage();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.message = Value.unwrap(Value.decode(reader, reader.uint32()));
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.jsonString = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            message: isSet(object?.message) ? object.message : undefined,
            jsonString: isSet(object.jsonString) ? globalThis.String(object.jsonString) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.message !== undefined) {
            obj.message = message.message;
        }
        if (message.jsonString !== undefined) {
            obj.jsonString = message.jsonString;
        }
        return obj;
    },
    create(base) {
        return WebViewAppMessage.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseWebViewAppMessage();
        message.message = object.message ?? undefined;
        message.jsonString = object.jsonString ?? undefined;
        return message;
    },
};
messageTypeRegistry.set(WebViewAppMessage.$type, WebViewAppMessage);
function createBaseWebViewStateMessage() {
    return { state: undefined };
}
export const WebViewStateMessage = {
    $type: "devvit.ui.effects.web_view.v1alpha.WebViewStateMessage",
    encode(message, writer = _m0.Writer.create()) {
        if (message.state !== undefined) {
            Struct.encode(Struct.wrap(message.state), writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseWebViewStateMessage();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.state = Struct.unwrap(Struct.decode(reader, reader.uint32()));
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return { state: isObject(object.state) ? object.state : undefined };
    },
    toJSON(message) {
        const obj = {};
        if (message.state !== undefined) {
            obj.state = message.state;
        }
        return obj;
    },
    create(base) {
        return WebViewStateMessage.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseWebViewStateMessage();
        message.state = object.state ?? undefined;
        return message;
    },
};
messageTypeRegistry.set(WebViewStateMessage.$type, WebViewStateMessage);
function createBaseWebViewPostMessageEffect() {
    return { webViewId: "", app: undefined, state: undefined };
}
export const WebViewPostMessageEffect = {
    $type: "devvit.ui.effects.web_view.v1alpha.WebViewPostMessageEffect",
    encode(message, writer = _m0.Writer.create()) {
        if (message.webViewId !== "") {
            writer.uint32(10).string(message.webViewId);
        }
        if (message.app !== undefined) {
            WebViewAppMessage.encode(message.app, writer.uint32(18).fork()).ldelim();
        }
        if (message.state !== undefined) {
            WebViewStateMessage.encode(message.state, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseWebViewPostMessageEffect();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.webViewId = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.app = WebViewAppMessage.decode(reader, reader.uint32());
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.state = WebViewStateMessage.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            webViewId: isSet(object.webViewId) ? globalThis.String(object.webViewId) : "",
            app: isSet(object.app) ? WebViewAppMessage.fromJSON(object.app) : undefined,
            state: isSet(object.state) ? WebViewStateMessage.fromJSON(object.state) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.webViewId !== "") {
            obj.webViewId = message.webViewId;
        }
        if (message.app !== undefined) {
            obj.app = WebViewAppMessage.toJSON(message.app);
        }
        if (message.state !== undefined) {
            obj.state = WebViewStateMessage.toJSON(message.state);
        }
        return obj;
    },
    create(base) {
        return WebViewPostMessageEffect.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseWebViewPostMessageEffect();
        message.webViewId = object.webViewId ?? "";
        message.app = (object.app !== undefined && object.app !== null)
            ? WebViewAppMessage.fromPartial(object.app)
            : undefined;
        message.state = (object.state !== undefined && object.state !== null)
            ? WebViewStateMessage.fromPartial(object.state)
            : undefined;
        return message;
    },
};
messageTypeRegistry.set(WebViewPostMessageEffect.$type, WebViewPostMessageEffect);
function isObject(value) {
    return typeof value === "object" && value !== null;
}
function isSet(value) {
    return value !== null && value !== undefined;
}
